import React from "react";
import { Dna, CirclesWithBar } from "react-loader-spinner";

const CustomLoader = () => {
  return (
    <>
      <div className="loader-overlay">
        <div className="loader">
          {/* <Dna
            visible={true}
            height="100"
            width="100"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          /> */}
          <CirclesWithBar
            height="100"
            width="100"
            color="#6372ff  "
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            outerCircleColor=""
            innerCircleColor=""
            barColor=""
            ariaLabel="circles-with-bar-loading"
          />
        </div>
      </div>
    </>
  );
};

export default CustomLoader;
